var _circle, _circle2, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverlayDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9999,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9097_88318",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 33,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9999,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#E6E6E6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9097_88318)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99988 -4H8.49988V0.499824H12.9999V4.99965H17.4998V0.5H12.9999V-4H17.4999V0.5H21.9998V5H17.4998V9.49947H21.9998V13.9995H17.4998V9.49965H12.9999V13.9995H8.49986V9.49965H3.99988V4.99965H8.49986V0.5H3.99988V-4ZM8.49988 4.99982H12.9998V9.49947H8.49988V4.99982ZM21.9999 -4H26.4999V0.5H30.9998V5H26.5V9.49902H30.9999V13.999H26.4999V9.5H22V5H26.4998V0.5H21.9999V-4ZM17.4998 18.5004H21.9998V23.0004H17.4998V18.5005H12.9998V14.0005H17.4998V18.5004ZM35.5 9.49902H39.9999V13.999H35.4999V9.5H31V5H35.5V9.49902ZM30.9999 18.5004H26.4999V14.0005H21.9999V18.5005H26.4999V23.0002H21.9999V27.5002H26.4999V23.0004H30.9999V18.5004ZM35.5 14H31V18.5H35.5V14Z",
    fill: "#E6E6E6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.601 27.3081C20.5248 33.011 10.9746 32.895 5.03982 26.9602C-0.895008 21.0253 -1.01099 11.4751 4.69186 5.39899L26.601 27.3081Z",
    fill: "#121212",
    stroke: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayDark);
export default __webpack_public_path__ + "static/media/overlay-dark.8578ad18.svg";
export { ForwardRef as ReactComponent };